import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';

export default class WniCEPolicyService {

    static getAccountPolicyDetails(policyNumber, authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('wnicepolicy'), 'getAccountPolicyDetails', [policyNumber], authHeader);
    }

    /**
     * get policy audit details 
     * 
     * @param {String} policyNumber 
     * @param {Object} authHeader 
     * @returns 
     */
    static getAuditDetailsForPolicy(policyNumber, authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('wnicepolicy'), 'getAuditDetailsForPolicy', [policyNumber], authHeader);
    }

    static raiseDispute(auditDisputeDto, authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('wnicepolicy'),
            'raiseDispute', [auditDisputeDto], authHeader);
    }

}
